import { Cancel } from '@material-ui/icons'
import React from 'react'
import {
  Edit,
  EditProps,
  useTranslate,
  SimpleForm,
  TextInput,
  SaveButton,
  Toolbar,
  ToolbarProps,
  TextField,
  ShowButton,
  FunctionField,
  BooleanInput,
} from 'react-admin'
import { LogSchemeDataDto } from '../../../../core/dto/log-scheme-data.dto'
import { RAColorPicker } from '../../../common/RAColorPicker'

export const validateLogSchemeDataEdit = (values: LogSchemeDataDto) => {
  const errors: { [n: string]: string } = {}
  if (!values.text) {
    errors.text = 'ra.validation.required'
  }
  return errors
}

const EditTitle = ({ ...props }) => {
  const { record: scheme } = props
  const translate = useTranslate()
  return (
    <span>
      {translate('resources.log-scheme-data.titles.edit')}: {scheme?.id}.{' '}
      {scheme?.text}
    </span>
  )
}

const EditToolbar = (props: ToolbarProps) => (
  <Toolbar {...props}>
    <SaveButton />
    <ShowButton icon={<Cancel />} label="const.cancel" />
  </Toolbar>
)

export const LogSchemeDataEdit = (props: EditProps) => {
  const translate = useTranslate()

  return (
    <Edit {...props} hasShow={false} title={<EditTitle />}>
      <SimpleForm
        redirect="show"
        toolbar={<EditToolbar />}
        validate={validateLogSchemeDataEdit}
      >
        <TextField source="id" label="ID" />
        <FunctionField<LogSchemeDataDto>
          source="language"
          render={(record?: LogSchemeDataDto) =>
            translate(`settings.language.${record?.language}`)
          }
        />
        <TextInput source="text" fullWidth multiline />
        <RAColorPicker source="color" />
        <BooleanInput source="hiddenInSimpleView" />
        <TextField source="schemeId" />
      </SimpleForm>
    </Edit>
  )
}
